export enum SterilizationStatus {
    None = 'None',
    Spayed = 'Spayed',
    Neutered = 'Neutered'
}

